"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client'
import TaskModalDialog from './TaskModalDialog'
import { useAgreementComplianceModal } from './useAgreementComplianceModal'

interface AgreementComplianceModalProps {
  campaignId: string
  campaign: CampaignDetailModel
  isOpen: boolean
  onClose: () => void
  tasks: AutopilotTaskDto[]
}

const AgreementComplianceModal = ({
  campaignId,
  campaign,
  isOpen,
  onClose,
  tasks,
}: AgreementComplianceModalProps) => {
  const {
    completeDisabled,
    filteredDocuments,
    onSaveCurrentPage,
    renderPage,
  } = useAgreementComplianceModal({
    campaignId,
    campaign,
    isOpen,
    tasks,
  })

  return (
    <TaskModalDialog
      title={'Agreement Compliance'}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      documents={filteredDocuments}
      campaignId={campaignId}
      campaign={campaign}
      onSaveCurrentPage={onSaveCurrentPage}
      completeDisabled={completeDisabled}
      renderPage={renderPage}
    />
  )
}

export default AgreementComplianceModal
